import Icon from '../Icon/Icon';
import { useLanguage } from '../../../context/LanguageContext';

function WhatsAppButton() {
  const { translate } = useLanguage();
  return (
    <a
      aria-label={translate('Chat with Sanjeevi Grace Herbals on WhatsApp')}
      className="whatsapp-fab"
      href="https://wa.me/917530037100"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Icon name="message" />
      <span>{translate('Chat with Us')}</span>
    </a>
  );
}

export default WhatsAppButton;
